import { apiPaths, wikinaePaths } from '@mirinae/shared/defines/paths';
import { httpAPI } from './http';

export const EntriesAPI = (() => {
    function EntriesAPIConstructor(host) {
        this.apiHost = host || '';
    }
    EntriesAPIConstructor.prototype = {
        // list(opt) { // this API only for editor
        //     const option = {
        //         search: '',
        //         itemOffset: 0,
        //         itemsPerPage: 100,
        //         sort: { updated: -1 },
        //     };
        //     return httpAPI(this.apiHost, apiPaths.entryList, { data: { ...option, ...opt } });
        // },

        view(id) {
            const option = {
                method: 'get',
            };
            return httpAPI(this.apiHost, `${apiPaths.entryView}/${id}`, option);
        },

        entryBookmark(id, action) {
            const option = {
                data: {
                    entryID: id,
                    action: action || 'add' // add | delete
                }
            };
            return httpAPI(this.apiHost, apiPaths.entryBookmark, option);
        },

        bookmarks() {
            const option = {
                method: 'get',
                data: {
                    skip: 0, limit: 10000, order: { updated: -1 }
                },
            };
            return httpAPI(this.apiHost, apiPaths.bookmarks, option);
        },

        search(opt) {
            const option = {
                search: '',
                itemOffset: 0,
                itemsPerPage: 100,
                sort: { updated: -1 },
            };
            return httpAPI(this.apiHost, apiPaths.search, { data: { ...option, ...opt } });
        },

        searchterms(prefix) {
            const option = {
                data: {
                    prefix: prefix || '',
                    maxResults: 6,
                },
            };
            return httpAPI(this.apiHost, apiPaths.searchterms, option);
        },

        usersearchterms() {
            const option = {
                method: 'get',
            };
            return httpAPI(this.apiHost, apiPaths.usersearchterms, option);
        },

        clearusersearchterms() {
            const option = {
                method: 'get',
            };
            return httpAPI(this.apiHost, apiPaths.clearusersearchterms, option);
        },

    };

    return EntriesAPIConstructor;
})();

export const entriesAPI = new EntriesAPI();